<template>
  <div class="partner">
    <div class="banner">
      <img
        class="banner_img"
        src="../../static/img/hzhb_banner.png"
        alt=""
      >
    </div>
    <ul class="partner_con w1200">
      <li>
        <img src="../../static/img/hzhb_rb.png" alt="">
        <div class="bj_img">
          <div class="lj" @click="skip('http://www.epicc.com.cn/')" >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj" @click="$router.push({path:'/cooperative?id=0'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_zh.png" alt="">
        <div class="bj_img">
          <div class="lj"  @click="skip('http://www.cic.cn/')" >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj" @click="$router.push({path:'/cooperative?id=1'})" >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_tp.png" alt="">
        <div class="bj_img">
          <div class="lj" @click="skip('http://www.cntaiping.com/')"  >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=2'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_as.png" alt="">
        <div class="bj_img">
          <div class="lj "  @click="skip('http://www.axatp.com')" >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=3'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_dh.png" alt="">
        <div class="bj_img">
          <div class="lj"  @click="skip('http://www.edhic.com/')">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=4'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
       <li>
        <img src="../../static/img/hzhb_zj.png" alt="">
        <div class="bj_img">
          <div class="lj"   @click="skip('http://www.zking.com/')" >
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=5'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_lb.png" alt="">
        <div class="bj_img">
          <div class="lj"  @click="skip('http://www.libertymutual.com.cn/')">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc"  src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=6'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>
      <li>
        <img src="../../static/img/hzhb_za.png" alt="">
        <div class="bj_img">
          <div class="lj"  @click="skip('https://www.zhongan.com')">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_lj1.png" alt="">
              <img class="yc" src="../../static/img/hzhb_lj.png" alt="">  
            </span>
            <span class="wz">相关链接</span>
          </div>
          <div class="lj"  @click="$router.push({path:'/cooperative?id=7'})">
            <span class="yt">
              <img class="xs" src="../../static/img/hzhb_xxpl1.png" alt=""> 
              <img class="yc" src="../../static/img/hzhb_xxpl.png" alt="" >
            </span>
            <span class="wz">信息披露</span>
          </div>
        </div>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      // partner: [
      //   {
      //     img: require("../../static/img/hzhb_rb.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_zh.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_tp.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_as.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_dh.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_zj.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_lb.png")
      //   },
      //   {
      //     img: require("../../static/img/hzhb_za.png")
      //   }
      // ]
    }
  },
  methods: {
    skip (url) {
      location.href = url
    }
  }
};
</script>

<style  lang="scss" scoped>
.partner_con {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 60px 40px;
  li {
    margin: 30px 20px;
    position: relative;
    .bj_img {
      position: absolute;
      top: 0;
      opacity: 0;
      transition: all 0.6s;
      background: url(../../static/img/hzhb_zzc.png);
      height: 200px;
      width: 300px;
      display: flex;
      justify-content: space-around;
      margin: 0 auto;
       .lj {
        width: 85px;
        height: 104px;
        text-align: center;
        font-size: 20px;
        color: #343128;
        padding-top: 55px;
        .yt {
          display: inline-block;
          background: #fff;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          position: relative;
          opacity: .8;
           img {
            display: block;
            width: 40px;
            height: 40px;
            margin: 16px auto;
          }
           
          .yc {
            position: absolute;
            top: 0;
            left: 15px;
            opacity: 0;
          }
        }
        }
      .lj:hover{
            .yt>.yc {
              opacity: 1;
              cursor: pointer;
            }
            .yt>.xs{
                opacity: 0;
            }
            .wz{
              color: #5182c4;
              cursor: pointer;

            }
            .yt{
              opacity:1;
            }
         }
    }
  }
  li:nth-child(2) {
    margin: 30px 70px;
  }
  li:nth-child(5) {
    margin: 30px 70px;
  }
  li:nth-child(8) {
    margin: 30px 70px;
  }
  li:hover .bj_img {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Partner.vue